// Binds to elements with 'invalid-message' so that when html5 validation
// kicks in that message is shown instead. The calls to setCustomValidity
// are browser-native html5 calls that are available in all html5 browsers.
// http://www.html5rocks.com/en/tutorials/forms/constraintvalidation/
const Html5Validation = {
  bindCustomInvalidMessage() {
    $('[data-invalid-message]').each(function () {
      const invalidMessage = $(this).data('invalid-message');
      $(this)
        .on('invalid', function () { this.setCustomValidity(invalidMessage); })
        .on('change', function () { this.setCustomValidity(''); });
    });
  },
};

Html5Validation.bindCustomInvalidMessage();
